import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    certificateStatus: [],
    certificateStatusLoaded: false,
  }),
  mutations: {
    SET_CERTIFICATESTATUS(state, categories) {
      state.certificateStatus = categories
      state.certificateStatusLoaded = true
    },
  },
  actions: {
    async fetchCertificateStatus({ commit, state }) {
      if (!state.certificateStatusLoaded) {
        const res = await axios.get('certificate-status')
        const data = decryptData(res.data.payload).data.status
        const formatted = data.map((item, index) => ({
          id: item.id,
          value: item.id,
          label: index < 7 ? `${item.id} ${item.status}` : `${item.status}`,
        }))
        commit('SET_CERTIFICATESTATUS', [...formatted])
      }
    },
  },
  getters: {
    certificateStatus: state => state.certificateStatus,
    certificateStatusLoaded: state => state.certificateStatusLoaded,
  },
}
